import React, { useState, useEffect } from 'react';
import { createProfil } from '../api';
import { capture } from '../tracking/posthog';

function ProfilErstellen({ onZurueck, onErstellt }) {
  const [form, setForm] = useState({
    vorname: '',
    nachname: '',
    strasse: '',
    hausnummer: '',
    plz: '',
    ort: '',
    telefon: '',
    email: '',
  });
  const [fehler, setFehler] = useState(null);
  const [laedt, setLaedt] = useState(false);
  const [langsam, setLangsam] = useState(false);

  useEffect(() => { capture('profile_creation_started'); }, []);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLaedt(true);
    setFehler(null);
    const timer = setTimeout(() => setLangsam(true), 5000);
    try {
      const res = await createProfil(form);
      const dateiname = res.data.dateiname;
      capture('profile_created');
      onErstellt(dateiname);
    } catch (err) {
      if (err.response?.status === 409) {
        setFehler('Ein Profil mit diesem Namen existiert bereits. Öffne "Profile verwalten", suche die Kachel mit diesem Namen und lösche sie zuerst — dann kannst du es neu anlegen.');
      } else if (err.code === 'ECONNABORTED') {
        setFehler('Zeitüberschreitung – bitte erneut versuchen.');
      } else {
        setFehler('Profil konnte nicht erstellt werden.');
      }
    } finally {
      clearTimeout(timer);
      setLangsam(false);
      setLaedt(false);
    }
  };

  return (
    <div className="seite">
      <h2>Neues Profil anlegen</h2>
      <form onSubmit={onSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px' }}>
          <div>
            <label>Vorname</label>
            <input name="vorname" value={form.vorname} onChange={onChange} required />
          </div>
          <div>
            <label>Nachname</label>
            <input name="nachname" value={form.nachname} onChange={onChange} required />
          </div>
          <div>
            <label>E-Mail</label>
            <input name="email" type="email" value={form.email} onChange={onChange} required />
          </div>
          <div>
            <label>Telefon</label>
            <input name="telefon" value={form.telefon} onChange={onChange} required />
          </div>
          <div>
            <label>Straße</label>
            <input name="strasse" value={form.strasse} onChange={onChange} required />
          </div>
          <div>
            <label>Hausnummer</label>
            <input name="hausnummer" value={form.hausnummer} onChange={onChange} required />
          </div>
          <div>
            <label>PLZ</label>
            <input name="plz" value={form.plz} onChange={onChange} required />
          </div>
          <div>
            <label>Ort</label>
            <input name="ort" value={form.ort} onChange={onChange} required />
          </div>
        </div>

        {fehler && <p className="fehler">{fehler}</p>}

        <div className="btn-gruppe">
          <button type="button" className="btn-zurueck" onClick={onZurueck}>
            Zurück
          </button>
          <button type="submit" className="btn-primary" disabled={laedt}>
            {laedt ? 'Wird erstellt...' : 'Profil erstellen'}
          </button>
        </div>
        {langsam && (
          <p style={{ marginTop: 12, fontSize: 13, color: '#92400e', textAlign: 'center' }}>
            Der erste Start kann etwas länger dauern – bitte warten…
          </p>
        )}
      </form>
    </div>
  );
}

export default ProfilErstellen;
